import { render, staticRenderFns } from "./IconElementButton.vue?vue&type=template&id=4970f0f8&"
import script from "./IconElementButton.vue?vue&type=script&lang=js&"
export * from "./IconElementButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4970f0f8')) {
      api.createRecord('4970f0f8', component.options)
    } else {
      api.reload('4970f0f8', component.options)
    }
    module.hot.accept("./IconElementButton.vue?vue&type=template&id=4970f0f8&", function () {
      api.rerender('4970f0f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconElementButton.vue"
export default component.exports